import {Form, Input} from "antd";
import React from "react";
import {NormalInputStyle} from "@src/components/Common/Styles";

const OpenAIModelForm = (record: any) => {

    return (
        <>
            <Form.Item label={"Api Key"} name={["extra_data", "OPENAI_API_KEY"]} rules={[{ required: true }]}>
                <Input.Password placeholder={"Api Key"} visibilityToggle={false} style={NormalInputStyle}/>
            </Form.Item>

            <Form.Item label={"Assistant ID"} name={["extra_data", "OPENAI_ASSISTANT_ID"]} rules={[{ required: true }]}>
                <Input placeholder={"Assistant ID"} style={NormalInputStyle}/>
            </Form.Item>

        </>
    )
}

export default OpenAIModelForm;